module.exports = __webpack_public_path__ + "static/media/icon-buy-bid.35d78739.svg";